import { Injectable, Injector } from "@angular/core";
import { environment } from "@environments/environment";
import { Service } from "@services/service";

@Injectable()
export class MachineAvailabilityService extends Service {
	constructor(injector: Injector) {
		super("MachineAvailability", injector);
	}

	// API	
	forMachine(id: number) {
		return this.http.get(`${environment.server.apiURL}/${this.endpoint}/ForMachine/${id}` );
	}
}